<template lang="pug">
  .print-map
    p Enter in the title and description, then press print to generate a PDF
      |  of the map as it appears in the browser window.
    form
      v-text-field(
        v-model="title.value"
        :label="`Title (${title.chars}/${title.max})`"
        :color="max(title.chars, title.max)"
      )
      v-textarea(
        v-model="description.value"
        :label="`Description (${description.chars}/${description.max})`"
        :color="max(description.chars, description.max)"
      )
      .form-actions
        v-btn(class="black--text" color="secondary" :loading="printing" @click="printMap" :disabled="overflow")
          v-icon(left) print
          | Print
        v-btn(dark @click="clear")
          v-icon(left) clear
          | Clear
</template>

<script>
import { printMap } from '@/services/map'
import axios from 'axios'
import store from '../store'

export default {
  data () {
    return {
      title: {
        value: '',
        chars: 0,
        max: 60
      },
      description: {
        value: '',
        chars: 0,
        max: 200
      },
      printing: false
    }
  },
  created () {
    store.subscribe((mutation) => {
      if (mutation.type === 'setselectedmaptheme') {
        if (mutation.payload && Object.keys(mutation.payload).length !== 0) {
          this.title.value = mutation.payload.name
          this.description.value = mutation.payload.description
        } else {
          this.title.value = ''
          this.description.value = ''
        }
      }
    })
  },
  computed: {
    overflow () {
      return this.title.chars > this.title.max || this.description.chars > this.description.max
    }
  },
  methods: {
    max (max, val) {
      if (max > val) return 'red'
      return 'green'
    },
    clear () {
      this.title.value = ''
      this.description.value = ''
    },
    async printMap () {
      this.printing = true
      try {
        const url = await printMap(this.title.value, this.description.value)
        let found
        for (let index = 0; index < 20; index++) {
          try {
            await new Promise(resolve => setTimeout(resolve, 5000))
            await axios.get(url)
            found = true
            break
          } catch (err) {}
        }
        if (!found) throw Error

        this.$root.$emit('snackbar-message', { text: `Report ready: <a href="${url}" download="blah.pdf" target="_blank">download</a> ` })
        this.printing = false
      } catch (err) {
        console.error(err)
        this.printing = false
        if (err.message !== '1') this.$root.$emit('snackbar-message', 'Error printing map')
      }
    }
  },
  watch: {
    'title.value': function (t) {
      this.$nextTick(() => {
        this.title.chars = t.length
      })
    },
    'description.value': function (d) {
      this.$nextTick(() => {
        this.description.chars = d.length
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .print-map
    padding 1em
    .v-input
      margin-top 16px
    .form-actions
      padding-top 1em
      button:nth-child(1)
        margin-left 0
</style>
